<lib-form-field-container
    #anchor
    [kind]="FormContainerKind.Date"
    [isOptional]="isOptional"
    [hideErrors]="popupOpen">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-content prefixText select="[prefixText]"></ng-content>
    <ng-content suffixText select="[suffixText]"></ng-content>
    <ng-content bottomMenu select="[bottomMenu]"></ng-content>

    <ng-container prefixIcon>
        <lib-icon-button 
            [class.cursor-pointer]="!isDisabled"
            [kind]="ButtonKind.FormField"
            [disabled]="isDisabled"
            [size]="ButtonSize.Large"
            [icon]="prefixIcon"
            (clicked)="OpenDatePicker()">
        </lib-icon-button>
    </ng-container>

    <ng-container readOnly>
        <div class="wrapper-content" #providedReadOnly>
            <ng-content select="[readOnly]" ></ng-content>
        </div>
        <div class="default-content">
            @if (formControl.value) {
                {{ formControl.value.Render() }}
            } @else {
                <ng-container i18n="@@CommonNotSpecifiedLabel">
                    Not specified
                </ng-container>
            }
        </div>
    </ng-container>

    @if (isOptional && !isReadOnly) {
        <lib-button menu
            [disabled]="isDisabled || isLoading"
            [kind]="ButtonKind.Link"
            [qaTag]="qaTag + '-clear-button'"
            (clicked)="Clear()">
            <ng-container label i18n="@@FormFieldClearLabel">Clear</ng-container>
        </lib-button>
    }

        <input #input [id]="formFieldID" [hidden]="isLoading || isReadOnly"
        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
        [attr.aria-required]="formControl.isRequired"
        mbsc-datepicker
        [formControl]="viewControl"
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        [min]="minDateJS"
        [max]="maxDateJS"
        [anchor]="anchor?.containerBox?.nativeElement"
        [rtl]="localeInfo.RightToLeft"
        [attr.placeholder]="placeholderText"
        [touchUi]="false"
        [attr.data-sb-qa]="qaTag"
        (onChange)="ChangeEvent($event)"
        (onOpen)="PopupOpened($event)"
        (onClose)="PopupClosed()"
        (change)="$event.stopPropagation()"
        (onInit)="ComponentInitialized($event)"
        [dateFormat]="dateFormat | uppercase"
        themeVariant="light"
        theme="material"
        [focusOnClose]="false"
        [scrollLock]="false"
        [dayNamesShort]="localeInfo.AbbreviatedDayNames"
        [monthNames]="localeInfo.MonthNames"
        [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
        [dayNamesMin]="localeInfo.AbbreviatedDayNames"
        [firstDay]="firstDayOfWeek"
        (blur)="OnBlur()"
        (click)="OnClick($event)"
        (focus)="OnFocus()"/>

</lib-form-field-container>